import { InjectionToken, inject } from '@angular/core';
import type { Request, Response } from 'express';

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');

export function injectRequest(): Request | null {
    return inject(REQUEST, { optional: true });
}

export function injectResponse(): Response | null {
    return inject(RESPONSE, { optional: true });
}
